/**
 * An Object.entries alternative that returns typed [key, value] tuples.
 * Keys are typed as keyof T instead of string so iteration is type-safe.
 */
export function objectEntries<T extends object>(
  obj: T
): Array<[keyof T, T[keyof T]]> {
  return Object.entries(obj) as Array<[keyof T, T[keyof T]]>
}
